//Lista delle voci del menu
//Aggiungi un elemento nell'array per avere una nuova voce

import { names as guideTopics } from "containers/Guide/_topics";
import { menuIcons as icons } from "img/icons";

const admin = {
	name: "Amministrazione",
	url: "/administration",
	icon: icons.admin,
	iconHover: icons.admin_over,
};

const agrialerts = {
	name: "Allarmi",
	url: "/agrialerts",
	icon: icons.alert,
	iconHover: icons.alert_over,
};

const agriservice = {
	name: "Agri Service",
	url: "/agriservice",
	icon: icons.service,
	iconHover: icons.service_over,
};

const agriserviceV2 = {
	name: "Agri Service",
	url: "/agriserviceV2",
	icon: icons.service,
	iconHover: icons.service_over,
};

const agriPVservice = {
	name: "Agri Service",
	url: "/agripvservice",
	icon: icons.service,
	iconHover: icons.service_over,
};

const alerts = {
	name: "Allarmi",
	url: "/alerts",
	icon: icons.alert,
	iconHover: icons.alert_over,
};

const charts = {
	name: "Grafici",
	url: "/charts",
	icon: icons.chart,
	iconHover: icons.chart_over,
};

const chartsFreezing = {
	name: "Gestione Gelata",
	url: "/charts-freezing",
	icon: icons.freezing,
	iconHover: icons.freezing_over,
	guideTopic: guideTopics.GELATA,
};

const chartsIrrigation = {
	name: "Irrigazione",
	url: "/charts-irrigation",
	icon: icons.irrigation,
	iconHover: icons.irrigation_over,
	guideTopic: guideTopics.IRRIGAZIONE,
};

const chartsMicroclimate = {
	name: "Microclima",
	url: "/charts-microclimate",
	icon: icons.analysis,
	iconHover: icons.analysis_over,
};

const chartsPhytosanitary = {
	name: "Gestione Fitosanitaria",
	url: "/charts-phytosanitary",
	icon: icons.phyto,
	iconHover: icons.phyto_over,
};

const chartsSolar = {
	name: "Grafici",
	url: "/charts-solar",
	icon: icons.chart,
	iconHover: icons.chart_over,
};

const chartsTrap = {
	name: "Grafici",
	url: "/charts-trap",
	icon: icons.chart,
	iconHover: icons.chart_over,
};

const charts2 = {
	name: "Grafici",
	url: "/charts2",
	icon: icons.chart,
	iconHover: icons.chart_over,
};

const charts2Freezing = {
	name: "Gestione Gelata",
	url: "/charts2-freezing",
	icon: icons.freezing,
	iconHover: icons.freezing_over,
	guideTopic: guideTopics.GELATA,
};

const charts2Irrigation = {
	name: "Irrigazione",
	url: "/charts2-irrigation",
	icon: icons.irrigation,
	iconHover: icons.irrigation_over,
	guideTopic: guideTopics.IRRIGAZIONE,
};

const charts2Phytosanitary = {
	name: "Gestione Fitosanitaria",
	url: "/charts2-phytosanitary",
	icon: icons.phyto,
	iconHover: icons.phyto_over,
};

const configurationManager = {
	name: "Gestione configurazioni",
	url: "/configuration-manager",
	icon: icons.maintenance,
	iconHover: icons.maintenance_over,
};

const contactUs = {
	name: "Assistenza",
	url: "https://www.agrismartiot.it/contatti/",
	icon: icons.contact,
	iconHover: icons.contact_over,
};

const dashboard = {
	name: "Dashboard",
	url: "/",
	icon: icons.home,
	iconHover: icons.home_over,
};

const data = {
	name: "Dati",
	url: "/data",
	icon: icons.data,
	iconHover: icons.data_over,
};

const data1 = {
	name: "Dati 1",
	url: "/data1",
	icon: icons.data,
	iconHover: icons.data_over,
};

const data2 = {
	name: "Dati 2",
	url: "/data2",
	icon: icons.data,
	iconHover: icons.data_over,
};

const data1Solar = {
	name: "Dati centralina",
	url: "/data1-solar",
	icon: icons.data,
	iconHover: icons.data_over,
};

const data2Solar = {
	name: "Dati impianto",
	url: "/data2-solar",
	icon: icons.data,
	iconHover: icons.data_over,
};

const dataTrap = {
	name: "Dati",
	url: "/data-trap",
	icon: icons.data,
	iconHover: icons.data_over,
};

const devicesManager = {
	name: "Gestione dispositivi",
	url: "/devices-manager",
	icon: icons.device,
	iconHover: icons.device_over,
};

const dss = {
	name: "DSS",
	url: "/dss",
	icon: icons.dss,
	iconHover: icons.dss_over,
	guideTopic: guideTopics.DSS,
};

const dssAdversities = {
	name: "Avversità",
	url: "adversities",
	icon: icons.dss,
	iconHover: icons.dss_over,
};

const dssPhenology = {
	name: "Fenologia",
	url: "phenology",
	icon: icons.dss,
	iconHover: icons.dss_over,
};

const dssSettings = {
	name: "Impostazioni DSS",
	url: "settings",
	icon: icons.settings2,
	iconHover: icons.settings2_over,
};

const goBack = {
	name: "Indietro",
	action: 'goBack',
	icon: icons.back,
	iconHover: icons.back_over,
};

const maintenance = {
	name: "Manutenzione",
	url: "/guide/manutenzione",
	icon: icons.maintenance,
	iconHover: icons.maintenance_over,
	guideTopic: guideTopics.CENTRALINA,
};

const medium = {
	name: "Analisi Dati",
	url: "/review",
	icon: icons.analysis,
	iconHover: icons.analysis_over,
	guideTopic: guideTopics.ANALISI_DATI,
};

const medium2 = {
	name: "Analisi Dati",
	url: "/review2",
	icon: icons.analysis,
	iconHover: icons.analysis_over,
	guideTopic: guideTopics.ANALISI_DATI,
};

const meteoservice = {
	name: "Meteo Service",
	url: "/meteoservice",
	icon: icons.service,
	iconHover: icons.service_over,
};

const settings = {
	name: "Impostazioni",
	url: "/settings",
	icon: icons.settings,
	iconHover: icons.settings_over,
};

const statisticsDetails = {
	name: "Medie",
	url: "/statisticsDetails",
	icon: icons.chart2,
	iconHover: icons.chart2_over,
	guideTopic: guideTopics.MEDIE,
};

const statisticsDetailsV2 = {
	name: "Medie",
	url: "/statisticsDetailsV2",
	icon: icons.chart2,
	iconHover: icons.chart2_over,
	guideTopic: guideTopics.MEDIE,
};

const statsSolar = {
	name: "Medie",
	url: "/stats-solar",
	icon: icons.chart2,
	iconHover: icons.chart2_over,
};

const switchData = {
	name: "Dati",
	url: "switch-data",
	icon: icons.data,
	iconHover: icons.data_over,
};

const users = {
	name: "Gestione utenti",
	url: "/users",
	icon: icons.user,
	iconHover: icons.user_over,
};

export default {
	admin,
	agrialerts,
	agriservice,
	agriserviceV2,
	agriPVservice,
	alerts,
	charts,
	chartsFreezing,
	chartsIrrigation,
	chartsMicroclimate,
	chartsPhytosanitary,
	chartsSolar,
	chartsTrap,
	charts2,
	charts2Freezing,
	charts2Irrigation,
	charts2Phytosanitary,
	configurationManager,
	contactUs,
	dashboard,
	data,
	data1,
	data2,
	data1Solar,
	data2Solar,
	dataTrap,
	devicesManager,
	dss,
	dssAdversities,
	dssPhenology,
	dssSettings,
	goBack,
	maintenance,
	medium,
	medium2,
	meteoservice,
	settings,
	statisticsDetails,
	statisticsDetailsV2,
	statsSolar,
	switchData,
	users,
};

